var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 6.1875C4.14583 6.5 4.54167 6.65625 5 6.65625C5.45833 6.65625 5.84375 6.5 6.15625 6.1875C6.48958 5.85417 6.65625 5.45833 6.65625 5C6.65625 4.54167 6.48958 4.15625 6.15625 3.84375C5.84375 3.51042 5.45833 3.34375 5 3.34375C4.54167 3.34375 4.14583 3.51042 3.8125 3.84375C3.5 4.15625 3.34375 4.54167 3.34375 5C3.34375 5.45833 3.5 5.85417 3.8125 6.1875ZM1.6875 1.71875C2.60417 0.802083 3.70833 0.34375 5 0.34375C6.29167 0.34375 7.38542 0.802083 8.28125 1.71875C9.19792 2.61458 9.65625 3.70833 9.65625 5C9.65625 5.64583 9.48958 6.38542 9.15625 7.21875C8.84375 8.05208 8.45833 8.83333 8 9.5625C7.54167 10.2917 7.08333 10.9792 6.625 11.625C6.1875 12.25 5.8125 12.75 5.5 13.125L5 13.6562C4.875 13.5104 4.70833 13.3229 4.5 13.0938C4.29167 12.8438 3.91667 12.3646 3.375 11.6562C2.83333 10.9271 2.35417 10.2292 1.9375 9.5625C1.54167 8.875 1.17708 8.10417 0.84375 7.25C0.510417 6.39583 0.34375 5.64583 0.34375 5C0.34375 3.70833 0.791667 2.61458 1.6875 1.71875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationWhite);
export default __webpack_public_path__ + "static/media/location_white.3ef0511f885265a9666a9d045efa1f25.svg";
export { ForwardRef as ReactComponent };